import * as React from 'react';

import { Backbone$Id } from 'types/typescript/Backbone';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import HoverLayerTrigger from 'components/HoverLayerTrigger';
import Link from 'components/Link';
import Relationship from 'entities/Relationship';
import RelationshipActions from 'actions/RelationshipActions';
import RelationshipStore from 'stores/RelationshipStore';
import UserHovercard from 'users/components/UserHovercard';

type Props = {
  className?: string;
  children: React.ReactNode;
  userId: Backbone$Id;
  showSubscriptions?: boolean;
  neverShowStartChat?: boolean;
  placement?: 'left' | 'right' | 'bottom' | 'top';
  alignment?: 'top' | 'right' | 'bottom' | 'left';
};

type State = {
  relationship?: Relationship | null;
};

class UserLink extends React.Component<Props, State> {
  static getStores() {
    return [RelationshipStore];
  }

  static defaultProps = {
    neverShowStartChat: false,
  };
  static calculateState(_prevState: any, props: Props): State {
    return {
      relationship: RelationshipStore.getRelationship(props.userId),
    };
  }

  loadRelationship = () => {
    if (!this.state.relationship) {
      RelationshipActions.loadRelationship(this.props.userId);
    }
  };
  render() {
    const { neverShowStartChat, showSubscriptions, children, placement, alignment, ...props } =
      this.props;

    if (this.props.userId === CurrentUser.getUserId()) {
      return <Link {...props}>{children}</Link>;
    }

    const hovercard = (
      <UserHovercard
        relationship={this.state.relationship}
        neverShowStartChat={neverShowStartChat}
        showSubscriptions={showSubscriptions}
      />
    );

    return (
      <HoverLayerTrigger
        layer={hovercard}
        placement={placement}
        alignment={alignment}
        delayShow={400}
      >
        <Link {...props} onMouseEnter={this.loadRelationship}>
          {children}
        </Link>
      </HoverLayerTrigger>
    );
  }
}

// @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
export default Container.create(UserLink, { withProps: true });
